import { render, staticRenderFns } from "./DefiDepositFTM.vue?vue&type=template&id=bd18588a&"
import script from "./DefiDepositFTM.vue?vue&type=script&lang=js&"
export * from "./DefiDepositFTM.vue?vue&type=script&lang=js&"
import style0 from "./DefiDepositFTM.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports